<script lang="ts">
    import axios from 'axios';
    import Shgrid from '../../components/shgrid/shgrid.svelte';
    import type {Column} from '@/components/shgrid';
    import type Vehicles from "@/schemas/public/Vehicles";
    import * as Table from '@/components/ui/table/index.js';
    import PicklistBadge from '@/components/ui/picklist-badge/PicklistBadge.svelte';

    type Row = Vehicles;

    type StatusOption = {
        value: string;
        label: string;
    };

    type Props = {
        view : string;
        onRowClick?: (row: Row) => void;
        statusOptions?: StatusOption[];
    };

    let {view, onRowClick, statusOptions = []}: Props = $props();


    const getRowLink = (row: Row) => route('vehicles.show', {vehicle: row.id});
    const includeLink = view != 'related';
    let cols = $state<Column<Row>[]>([
        {
            label: 'Make',
            key: 'make',
            cellRender: {
                type: 'text',
                label: (row) => row.make,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Registration',
            key: 'registration',
            cellRender: {
                type: 'text',
                label: (row) => row.registration ?? "",
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Current Job',
            key: 'active_job',
            cellRender: {
                type: 'text',
                label: (row) => row.active_job?.title ?? row.active_job?.job?.title ?? "",
                link: (row) =>  row.active_job ? route('jobs.show', { job: row.active_job?.culmex_job_id }) : undefined,
                highlightLink: true
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Seating Capacity',
            key: 'seating_capacity',
            cellRender: {
                type: 'text',
                label: (row) => row.seating_capacity,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Status',
            key: 'status',
            cellRender: {
                type: 'custom',
                snippet: statusBadgeSnippet,
            },
            sortable: true,
            filter: statusOptions.length > 0
                ? { type: 'select', options: statusOptions }
                : { type: 'string' },
        },

    ]);

</script>

{#snippet statusBadgeSnippet(row: Row)}
    <Table.Cell>
        {#if row.status_label}
            <PicklistBadge label={row.status_label} color={row.status_color ?? 'gray'} />
        {:else}
            <span class="text-muted-foreground">{row.status ?? 'N/A'}</span>
        {/if}
    </Table.Cell>
{/snippet}

<div>
    <Shgrid
        fetcher={async ({ limit, offset, filters, sorter }) => {
        const res = await axios.get(route('web-api.Vehicle.index', { limit, offset, filters, sorter }));
        return { data: res.data, error: null };
    }}
        limit={100}
        bind:columns={cols}
        {...(view === 'related' ? { onRowClick } : {})}
    ></Shgrid>
</div>

